import { useCallback, useState } from 'react';
import { useConfig, useSwitchChain } from 'wagmi';
import { getAccount } from '@wagmi/core';
import useAppStore from '../store/rootStore';

export function useEnsureChain() {
  const config = useConfig();
  const { switchChainAsync } = useSwitchChain();
  const configChainId = useAppStore((state) => state.config?.chain.id);
  const [isSwitching, setIsSwitching] = useState(false);

  const ensureChain = useCallback(async () => {
    const currentChainId = getAccount(config).chainId;
    if (configChainId && currentChainId !== configChainId) {
      setIsSwitching(true);
      try {
        await switchChainAsync({ chainId: configChainId });
      } finally {
        setIsSwitching(false);
      }
    }
  }, [config, configChainId, switchChainAsync]);

  return {
    ensureChain,
    isSwitching,
    configChainId,
  };
}
